export default "__VITE_ASSET__ObuldvE$__"